import axios from 'axios'
import { MODULES_BASE_URLS } from 'src/common/constants'

export default class EntityManagementService {
    static instance

    static getInstance() {
        if (!EntityManagementService.instance) {
            EntityManagementService.instance = new EntityManagementService()
        }
        return EntityManagementService.instance
    }

    async fetchEntitesList(params = {}, module = 'wb') {
        const token = window.localStorage.getItem(
            'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
        );

        const response = await axios.get(
            `${MODULES_BASE_URLS[module]}/entity_management/legal/list`,
            {
                params: params,
                headers: token ? {
                    Authorization: `Bearer ${token}`
                } : {}
            }
        )

        return response.data?.data || []
    }

    async fetchInstituteList(params = {}, entityId, module = 'wb') {
        const response = await axios.get(
            `${MODULES_BASE_URLS[module]}/entity_management/institute/legal_entity/${entityId}/list`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data || []
    }

    async fetchDivisionList(params = {}, instituteId, module = 'wb') {
        const response = await axios.get(
            `${MODULES_BASE_URLS[module]}/entity_management/division/institute/${instituteId}/list`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data || []
    }

}
